(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evanny-complementos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ev-complement')){
customElements.define('ev-complement',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const form=this.querySelector('form'),button=this.querySelector('button'),status=this.querySelector('[role="status"]'),select=this.querySelector('select');
select?.addEventListener('change',()=>{
const o=select.selectedOptions[0];this.querySelector('[data-com-price]').textContent=o.dataset.price;
const img=this.querySelector('img');if(img&&o.dataset.image){img.removeAttribute('srcset');img.src=o.dataset.image;}
status.textContent='';button.textContent=this.dataset.add;
});
form.addEventListener('submit',async e=>{
e.preventDefault();if(this.busy)return;this.busy=true;button.disabled=true;if(select)select.disabled=true;button.textContent=this.dataset.busy;status.textContent='';
try{
const id=select?select.value:form.querySelector('[name="id"]').value;
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||this.dataset.error);
button.textContent=this.dataset.added;status.textContent=this.dataset.added;
try{
const drawer=document.querySelector('cart-drawer');
if(drawer&&result.sections?.['cart-drawer']&&result.sections?.['cart-icon-bubble']){
drawer.setActiveElement(button);drawer.classList.remove('is-empty');drawer.renderContents(result);
}
}catch(error){}}catch(error){status.textContent=error.message||this.dataset.error;button.textContent=this.dataset.add;status.style.color='#a12020';}
finally{this.busy=false;button.disabled=false;if(select)select.disabled=false;}
});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evanny-product-support"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('evanny-quantity-guide')) {
  customElements.define('evanny-quantity-guide', class extends HTMLElement {
    connectedCallback() {
      this.core = document.querySelector('product-info[id^="MainProduct"]');
      if (!this.core || this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-guide-variants]').textContent);
      this.button = this.querySelector('[data-select-two]');
      this.total = this.querySelector('[data-guide-total]');
      this.sync = this.update.bind(this);
      this.core.addEventListener('change', this.sync);
      this.core.addEventListener('input', this.sync);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.core, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled', 'max', 'min']});
      this.button.addEventListener('click', () => {
        const input = this.core.querySelector('input[name="quantity"]');
        if (!input || this.button.disabled) return;
        input.value = '2';
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));
        this.update();
      });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.core?.removeEventListener('change', this.sync);
      this.core?.removeEventListener('input', this.sync);
      this.ready = false;
    }
    update() {
      const input = this.core.querySelector('input[name="quantity"]');
      const id = this.core.querySelector('product-form input[name="id"]')?.value;
      const variant = this.variants.find(v => String(v.id) === id);
      const count = Number(input?.value || 1);
      const min = Number(input?.min || 1), max = Number(input?.max || Infinity), step = Number(input?.step || 1);
      const canSelect = variant?.available && input && min <= 2 && max >= 2 && (2 - min) % step === 0;
      this.button.disabled = !canSelect;
      this.button.textContent = !canSelect ? this.dataset.unavailableLabel : count === 2 ? this.dataset.selectedLabel : this.dataset.selectLabel;
      if (!variant || !Number.isInteger(count) || count < 1) { this.total.textContent = ''; return; }
      const price = new Intl.NumberFormat(this.dataset.locale === 'es' ? 'es-MX' : (this.dataset.locale || 'es-MX'), {style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol'}).format(variant.price * count / 100);
      this.total.textContent = this.dataset.totalLabel.replace('__COUNT__', count).replace('__GRAMS__', count * 100).replace('__TOTAL__', price + ' ' + this.dataset.currency);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evanny-reviews-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('evanny-rating-link')) {
    customElements.define('evanny-rating-link', class extends HTMLElement {
      connectedCallback() {
        const template = document.getElementById('ev-rating-summary-template');
        if (!template || this.childElementCount) return;
        this.append(template.content.cloneNode(true));
        this.querySelector('a').addEventListener('click', event => {
          const target = document.getElementById(event.currentTarget.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          target.tabIndex = -1;
          target.focus({preventScroll:true});
          target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
        });
      }
    });
  }

  if (!customElements.get('evanny-review-panel')) {
    customElements.define('evanny-review-panel', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.items = [...this.querySelectorAll('[data-review-item]')];
        this.source = this.querySelector('[data-review-source]');
        this.rating = this.querySelector('[data-review-rating]');
        this.more = this.querySelector('[data-review-more]');
        this.result = this.querySelector('[data-review-results]');
        this.limit = 4;
        this.querySelector('[data-review-filters]').hidden = false;
        const resetPage = () => { this.limit = 4; this.update(); };
        this.source.addEventListener('change', resetPage);
        this.rating.addEventListener('change', resetPage);
        this.more.addEventListener('click', () => {
          const previousLimit = this.limit;
          this.limit += 4;
          this.update();
          const next = this.matches[previousLimit];
          if (next) { next.tabIndex = -1; next.focus({ preventScroll: true }); }
        });
        this.querySelector('[data-review-reset]').addEventListener('click', () => {
          this.source.value = 'all'; this.rating.value = 'all'; resetPage(); this.source.focus();
        });
        const dialog = this.querySelector('dialog');
        if (dialog) {
          const track = dialog.querySelector('[data-photo-track]');
          const slides = [...track.querySelectorAll('[data-photo-slide]')];
          const count = dialog.querySelector('[data-photo-count]');
          const previous = dialog.querySelector('[data-photo-prev]');
          const next = dialog.querySelector('[data-photo-next]');
          let index = 0;
          const refresh = () => {
            count.textContent = (index + 1) + ' / ' + slides.length;
            previous.disabled = index === 0;
            next.disabled = index === slides.length - 1;
          };
          const go = (position, smooth = true) => {
            index = Math.max(0, Math.min(slides.length - 1, position));
            track.scrollTo({left:index * track.clientWidth,behavior:smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
            refresh();
          };
          this.querySelectorAll('[data-review-photo]').forEach(link => link.addEventListener('click', event => {
            event.preventDefault();
            const position = slides.findIndex(slide => new URL(slide.dataset.photoUrl, document.baseURI).href === link.href);
            dialog.showModal();
            document.body.classList.add('ev-review-viewing');
            go(position < 0 ? 0 : position, false);
          }));
          track.addEventListener('scroll', () => {
            const position = Math.round(track.scrollLeft / track.clientWidth);
            if (position !== index) { index = position; refresh(); }
          }, {passive:true});
          previous.addEventListener('click', () => go(index - 1));
          next.addEventListener('click', () => go(index + 1));
          dialog.addEventListener('keydown', event => {
            if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
            if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
          });
          dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
          dialog.addEventListener('close', () => document.body.classList.remove('ev-review-viewing'));
          dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        }
        this.update();
      }
      update() {
        this.matches = this.items.filter(item => (this.source.value === 'all' || item.dataset.source === this.source.value) && (this.rating.value === 'all' || item.dataset.rating === this.rating.value));
        const visible = new Set(this.matches.slice(0, this.limit));
        this.items.forEach(item => { item.hidden = !visible.has(item); });
        this.more.hidden = visible.size >= this.matches.length;
        this.querySelector('[data-review-empty]').hidden = this.matches.length !== 0;
        this.result.textContent = this.dataset.resultLabel.replace('__shown__', visible.size).replace('__total__', this.matches.length);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evanny-trust-bar-lite"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ev-offer-countdown')) {
  customElements.define('ev-offer-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-inactive')) return;

      if (this.onOfferClick) this.removeEventListener('click', this.onOfferClick);
      this.onOfferClick = (event) => {
        if (event.target.closest('[data-ev-welcome-trigger]')) {
          document.dispatchEvent(new CustomEvent('evanny:welcome-open'));
        }
      };
      this.addEventListener('click', this.onOfferClick);

      this.mode = this.dataset.mode === 'fixed' ? 'fixed' : 'daily';
      this.clock = this.querySelector('.ev-countbar__clock');
      this.end = this.computeEnd();

      this.tick = () => {
        let remaining = Math.floor((this.end - Date.now()) / 1000);
        if (remaining <= 0) {
          if (this.mode === 'daily') {
            this.end = this.computeEnd();
            remaining = Math.floor((this.end - Date.now()) / 1000);
          } else {
            this.expire();
            return;
          }
        }
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % (this.mode === 'fixed' ? 24 : 1000),
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60
        };
        for (const [unit, value] of Object.entries(values)) {
          const el = this.querySelector('[data-unit="' + unit + '"]');
          if (el) el.textContent = String(value).padStart(2, '0');
        }
      };

      this.tick();
      this.timer = setInterval(this.tick, 1000);
      this.onVisibility = () => { if (!document.hidden) this.tick(); };
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    expire() {
      clearInterval(this.timer);
      if (this.clock) this.clock.hidden = true;
      const offer = this.querySelector('[data-offer]');
      if (offer) {
        offer.innerHTML = '';
        const text = document.createElement('span');
        text.className = 'ev-countbar__text';
        const bold = document.createElement('b');
        bold.textContent = this.dataset.regular || '';
        text.appendChild(bold);
        offer.appendChild(text);
      }
    }

    computeEnd() {
      if (this.mode === 'fixed') {
        const parsed = Date.parse(this.dataset.end);
        return isNaN(parsed) ? 0 : parsed;
      }
      const offset = 6 * 3600 * 1000;
      const localNow = Date.now() - offset;
      return (Math.floor(localNow / 86400000) + 1) * 86400000 + offset;
    }

    disconnectedCallback() {
      if (this.onOfferClick) this.removeEventListener('click', this.onOfferClick);
      clearInterval(this.timer);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'animate', 'scrolled-past-header');
      this.header.classList.add('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('input',debounce((event) => {const body = JSON.stringify({ note: event.target.value });fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });}, ON_CHANGE_DEBOUNCE_TIMER));
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
